// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"f68e0acf","516":"c656bca5","751":"ad9c04d4","925":"cb7093a8"}[chunkId] + ".chunk.css";
};